<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga w-100">
                <div class="h3Organization">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Trainings</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100" >
                            <button @click="searchBackEndHandler(isSearch, 1)" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                    placeholder="Search" autocomplete="off"
                                    @input="searchTraining" maxlength="50">
                        </div>
                    </div>
                    <div class="btn-container">
                        <button @click="openPopup" class="open-btn">
                            Filters
                        </button>
                    </div>
                    <div v-if="isPopupVisible" class="modal-overlay">
                        <div class="modal-content">
                            <div class="fullInputs mb-4">
                                <div class="oneInput w-100">
                                    <select id="filter_dates" class="form-select" v-model="sort" @change="getTrainings();closePopup();">
                                        <option value="false" selected disabled >Sort by Date</option>
                                        <option value="asc">Oldest</option>
                                        <option value="desc">Latest</option>
                                    </select>
                                </div>
                            </div>    
                            <div class="fullInputs mb-4">
                                <div class="oneInput w-100">
                                    <select id="statusSeacrh" v-model="status" class="form-select" @change="getTrainings();closePopup();">
                                        <option :value="null" disabled selected>Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="running">Running</option>
                                        <option value="ended">Ended</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="tab p-0">
                                <router-link class="text-decoration-none tablinks h2 m-0 active" to="/trainings" @click="closePopup">Public</router-link>
                                <router-link class="text-decoration-none tablinks h2 m-0" to="/private/trainings" @click="closePopup">Private</router-link>
                            </div>

                            <button @click="closePopup" class="close-btn">
                                x                          
                            </button>
                        </div>
                    </div>
                    <div v-if="trainings.length > 0 && permissions.includes('create training')" class="btn-container">
                        <button @click.prevent="CreateTraining">
                            Create
                        </button>
                    </div>
                    <div v-else></div>
                </div>
            </div>
            
            <div class="tabcontent tabcontent-border-style">
                <div class="table-container" v-if="trainings.length > 0">

                    <TableComponent :thead="role === 'user' ? theadUser : thead" :tbody="trainings" @sort="SortTraining" :keys="role === 'user' ? keysUser : keys" model="trainings" name="training"
                                    updateUrl="/complete-edit-trainings" :ids="trainings_ids" @update="updateTraining"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getTrainings" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="text-center d-flex flex-column justify-content-center align-items-center h-75 m-auto">
                    <div class="mb-4">
                        <h2 v-if="!searchFlag && !statusFlag"  class="">You Don't Have Any Public Trainings Yet</h2>
                        <h2 v-else>No Data</h2>
                    </div>
                    <div>
                        <button class="btn cssBtnCreateCompetition" v-if="permissions.includes('create training')  && (!searchFlag && !statusFlag)" @click.prevent="CreateTraining">Create Training</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import training from "../../../api-services/training";

    export default {
        name:'training',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted(){
            await this.$store.dispatch('activeTap', 'training');
            this.permissions = this.$store.state.auth.permissions;
            this.role = this.$store.state.auth.user.data.role[0];
            this.getTrainings();

        },
        data(){
            return {
                thead: [ 'Training Name', 'Type','Date Created' , 'Status'],
                keys:['name' , 'type' , 'start_date' , 'status'],
                theadUser:['Training Name','Date Created' , 'Type','Status'],
                keysUser:['name' , 'start_date' , 'type' , 'status'],
                permissions: [],
                trainings: [],
                filteredArray: [],
                isActive1:false,
                isActive2:false,
                originalTrainings: [],
                laravelData: {},
                error: null,
                search: '',
                searchFlag: false,
                isPopupVisible: false,
                category:'',
                score:false,
                sort: false,
                status:null,
                statusFlag:false,
                status2:false,
                role:''
            }
        },
        methods:{

            openPopup() {
                this.isPopupVisible = true;
            },
            closePopup() {
                this.isPopupVisible = false;
            },

            CreateTraining(){
                this.$router.push({name: 'create-training'});
            },
            async getTrainings(page=1){
                if (this.status !== null){
                    this.statusFlag = true;
                }
                try{
                    const response = await training.index(this.search  , this.status, this.sort === false ? this.sort = 'desc' : this.sort , page , 'public');
                    if (process.env.VUE_ENV === 'development')
                    console.log(response);
                    this.trainings = response.data.data;
                    this.laravelData = response.data;
                    this.originalTrainings = response.data.data;
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                    this.error = e;
                }
            },
            async SortTraining(){
                let status = !this.status2;
                this.originalTrainings.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateTraining(e){
                let filteredData = this.trainings.filter(function (data) {
                    return data.id != e;
                });
                this.trainings = filteredData;
            },
            searchTraining(e){
                // let searchedValue = e.target.value;
                // let searchedData = this.originalTrainings.filter((data) => data.name.includes(searchedValue));
                // this.trainings = searchedData;
                // this.searchFlag = true;
            },
            async searchBackEndHandler(searchFlag = false) {
                let dataLength = this.trainings.length;
                if (searchFlag && dataLength > 0) {
                    await this.getTrainings();
                }
            },
        }
    }
</script>
<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:100%;
        height:40px;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }

    /* popup style */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5); 
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000; 
    }


    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: var(--main-bg1-color); 
        padding: 60px 30px;
        border-radius: 8px;
        width: 340px;
        height: 360px;
        text-align: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    }


    .close-btn {
        background-color: #e74c3c;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        border-radius: 50px;
        width: 25px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        height: 25px;
        position: absolute;
        top: 10px;
        right: 10px;
    }


    /* responsive style */
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:20% !important;
        }
        .table-container :deep(thead :nth-child(2)){
        width:10% !important;
        }
        .table-container :deep(thead :nth-child(5)){
        width:12% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>
